import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Space, Tag, Typography } from 'antd';
import { ArrowLeftOutlined, HomeOutlined } from '@ant-design/icons';
import axios from 'axios';
import Sections from './Ware/Sections/Sections';

const { Title } = Typography;

function WarehouseS() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [warehouse, setWarehouse] = useState(null);

    useEffect(() => {
        axios.get(`/warehouses/${id}`).then(res => {
            setWarehouse(res.data);
        }).catch(() => {});
    }, [id]);

    return (
        <div>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 14,
                flexWrap: 'wrap',
                marginBottom: 20,
                paddingBottom: 16,
                borderBottom: '1px solid var(--border)',
            }}>
                <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/params/warehouses')}>Ortga</Button>
                <div style={{
                    width: 40,
                    height: 40,
                    borderRadius: 'var(--radius-md)',
                    background: 'var(--primary-light)',
                    color: 'var(--primary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 18,
                }}>
                    <HomeOutlined />
                </div>
                <div style={{ marginRight: 'auto' }}>
                    <Title level={4} style={{ margin: 0, letterSpacing: '-0.01em' }}>
                        {warehouse?.name || `Sklad #${id}`}
                    </Title>
                    <Space size={[6, 6]} wrap style={{ marginTop: 2 }}>
                        {warehouse?.location && <Tag color="blue">{warehouse.location}</Tag>}
                        {warehouse?.shop?.shopname && <Tag color="green">{warehouse.shop.shopname}</Tag>}
                    </Space>
                </div>
            </div>
            <Sections />
        </div>
    );
}

export default WarehouseS;
